module.exports = __webpack_public_path__ + "static/animation-709a2777edc1e17aaa36f6f10d9116fc.gif";